import { CommonUIService } from './../../../common/services/common.ui.service';
import { DoctorGender } from 'src/app/models/doctor/doctor-gender.model';
import { AuxillaryService } from 'src/app/sections/common/services/auxillary.service';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, FormGroup, Validators, FormControl } from '@angular/forms';
import { Doctor } from '../../../../models/doctor/doctor.model';
import { GeneralInformationService } from '../services/general-information.service';
import { Province } from '../../../../models/doctor/province.model';
import { Nationality } from '../../../../models/doctor/nationality.model';
import { DoctorService } from '../../services/doctor.service';

import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { changeNgbDateToCustomFormat } from '../../../common/services/change-ngb-date-to-custom-format';
import { SortList } from '../../../../sections/common/sortList';
import { Issuer } from '../../../../models/auxiliary/issuer.model';
import { IssuerService } from '../../../../sections/auxillary-tables/issuer/services/issuer.service';
import * as moment from 'moment';
import { Town } from 'src/app/models/doctor/doctor-town.model';
import { DropdownService } from 'src/app/sections/common/services/dropdown.service';
import { SweetAlertActions } from 'src/app/constants/sweet-alert-actions';
import { AuxiliaryTranslateValue } from 'src/app/models/common/auxiliary-translate-values';
import { DropDownOption } from 'src/app/models/common/dropdown-option';
import { ToastrService } from 'ngx-toastr';
import { CollegeDataPageService } from 'src/app/sections/college-data/services/college-data-page.service';
import { CollegeProvince } from 'src/app/models/college/college-province-model';
import { DoctorCorrespondence } from 'src/app/models/doctor/doctor-correspondence.model';
import { DoctorCorrespondenceService } from '../../doctor-correspondence/services/doctor-correspondence.service';
enum DocType {
  NIF = 1,
  NIE = 2,
  Passport = 3
}
@Component({
  selector: 'app-edit-general-information',
  templateUrl: './edit-general-information.component.html',
  styleUrls: ['./edit-general-information.component.scss']
})


export class EditGeneralInformationComponent implements OnInit {
  @Input() generalInformation: Doctor;
  @Input() doctorCorrespondenceData: DoctorCorrespondence;
  @Input() title: string;
  @Output() close: EventEmitter<any> = new EventEmitter();
  @ViewChild('modalLargeNew', { static: false }) child;
  @ViewChild('birthTownRef', { static: false }) birthTownRef;

  generalInformationForm: FormGroup;
  townsList: Town[] = [];
  provinces: Province[] = [];
  collegeProvinces: { id: number, provinceName: string }[] = [];
  nationlities: Nationality[] = [];
  genders: DoctorGender[] = [];
  generalInformationData: Doctor = {} as Doctor;
  auxiliaryTranslateValue: AuxiliaryTranslateValue
  birthTownControl = new UntypedFormControl();
  collegeProvinceControl = new UntypedFormControl();
  ngDocumentTypeList: DropDownOption[] = [];
  private isImageChanged = false;
  private imageFile: any;
  private image: any;
  submitted = false;
  isAdd = true;
  isEdit: boolean;
  isProvinceLengthOne = false;
  issuer: Issuer;
  latestCollegiateNumber: number;
  newCollegiateNumber = 0;
  selectedDocument: number = 0;
  selectedProvince: string = "";

  doctorCorrespondence: DoctorCorrespondence;
  doctorCorrespondenceForm: FormGroup;
  public searchTown = '';
  townControl = new UntypedFormControl();
  townID: number;
  countryId: number;
  provinceId: number;
  doctorId: number;

  minDate: object = { year: 1900, month: 1, day: 1 };
  maxDate: object = { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() };

  initialValue: 5000;
  age: number;

  validationMessages = {
    birthOfDate: {
      ngbDate: {
        invalid: 'common.validations.invalidDate',
        requiredAfter: 'common.validations.pastDate',
      }
    },
    birthTownId: {
      optionNotSelected: 'digitValidate',
    },
    mobileNumber: {
      pattern: "digitValidate",
    },
    email: {
      email: "invalidEmailAddress",
    },
  }

  constructor(private formBuilder: UntypedFormBuilder, private generalInformationService: GeneralInformationService, private commonUIService: CommonUIService,
    private doctorService: DoctorService, private toastService: ToastrService, private router: Router, private dropdownService: DropdownService,
    private issuerService: IssuerService, private translationService: TranslateService, private auxillaryService: AuxillaryService, public collegeDataPageService: CollegeDataPageService, public doctorCorrespondenceService: DoctorCorrespondenceService) {
    this.generalInformationData = new Doctor();
    this.auxiliaryTranslateValue = new AuxiliaryTranslateValue();
  }

  ngOnInit() {
    this.getAuxiliaryValues();
    this.initializeForAddGeneralInformation();
    this.initializeForAddDoctorCorrespondence();
    this.getDefaultIssuer();
    this.isAdd = true;
  }

  calculateAge(date: any, isEdit: boolean): void {
    if (!isEdit && date != null) {
      // Calculate age based on selected date
      const selectedDate = new Date(date.year, date.month - 1, date.day);
      const currentDate = new Date();
      this.age = currentDate.getFullYear() - selectedDate.getFullYear();

      // Adjust age if birthday hasn't occurred yet this year
      if (currentDate.getMonth() < selectedDate.getMonth() ||
        (currentDate.getMonth() === selectedDate.getMonth() && currentDate.getDate() < selectedDate.getDate())) {
        this.age--;
      }
    } else {
      // Calculate age based on birthdate string in 'YYYY-MM-DD' format using moment.js
      const birthDateString = this.generalInformationData.birthOfDate;
      const birthDate = moment(birthDateString, 'YYYY-MM-DD');
      if (birthDate.isValid()) {
        const today = moment();
        this.age = today.diff(birthDate, 'years');
      } else {
        this.age = 0;  // In case of invalid birthdate
      }
    }
  }

  getAuxiliaryValues() {
    this.getTownData();
    this.getProvinceData();
    this.getNationalityData();
    this.getGenderData();
    this.getCollegeProvincesData();
  }

  getCollegeProvincesData() {
    this.collegeProvinces = this.collegeDataPageService.college.collegeProvinces.map(p => ({ id: p.id, provinceName: p.province.provinceName }));
    if (this.generalInformationForm) {
      this.defaultProvinceSelection();
    }
  }

  getProvinceData() {
    this.generalInformationService.getProvinces().subscribe(
      (data: any) => {
        this.provinces = SortList(data._data, 'provinceName');
      },
      (error) => {
        this.failToast(error._message);
      }
    );
  }

  getTownData() {
    this.dropdownService.getTownList().subscribe(
      (data: any) => {
        this.townsList = SortList(data._data, 'townName');
      },
      (error) => {
        this.failToast(error._message);
      }
    );
  }


  getNationalityData() {
    this.generalInformationService.getNationalists().subscribe(
      (data: any) => {

        this.nationlities = SortList(data._data, 'nationalityName');
      },
      (error) => {
        this.failToast(error._message);
      }
    );
  }

  getGenderData() {
    this.auxillaryService.getGenderList().subscribe(
      (data: any) => {
        if (data._data != null) {
          this.genders = data._data.filter(gender => gender.status);
        }
      },
      (error) => {
        this.failToast(error._message);
      }
    );
  }

  async getDefaultIssuer() {
    return new Promise<void>((resolve, reject) => {
      this.issuerService.getDefaultIssuer().subscribe(
        (data: any) => {
          if (data._data != null) {
            this.issuer = data._data;
          }
          resolve();
        },
        (error: any) => {
          reject(error);
        }
      );
    });
  }

  //------------------On change methods--------------------------------------
  onChangeTown(town) {
    if (town) {
      this.generalInformationForm.controls.birthTownId.setValue(Number(town.id));
      this.generalInformationForm.controls.birthProvinceId.setValue(Number(town.provinceId));
      this.generalInformationForm.controls.birthProvinceName.setValue(town.province.provinceName);
      this.generalInformationData.birthProvince = null;
    }
  }

  onChangeCollegeProvince(province) {
    if (province) {
      this.generalInformationForm.controls.collegeProvinceId.setValue(Number(province.id));
      this.generalInformationForm.controls.collegeProvinceName.setValue(province.provinceName);
    }
  }

  onClearCollegeProvince() {
    this.collegeProvinceControl.setValue(null);
    this.generalInformationForm.controls.collegeProvinceId.setValue(null);
    this.generalInformationForm.controls.birthProvinceName.setValue(null);
  }

  isCollegeProvinceValueSelected(isValueSelected: any) {
    //value recieved, form group and control name
    this.commonUIService.novasearchDropDownValidator(isValueSelected, this.generalInformationForm, 'collegeProvinceId');
  }

  onChangeProvince($event) {
    if (this.generalInformationForm.controls.birthProvinceId.value) {
      this.generalInformationForm.controls.birthTownId.setValue(null);
      this.generalInformationData.birthTown = null;
      this.birthTownControl.setValue('');
      this.birthTownRef.nativeElement.click();
    } else {
      this.generalInformationData.birthProvince = null;
    }
  }

  onClearTown() {
    this.birthTownControl.setValue(null);
    this.generalInformationForm.controls.birthTownId.setValue(null);
    this.generalInformationForm.controls.birthProvinceId.setValue(null);
    this.generalInformationForm.controls.birthProvinceName.setValue(null);
    this.generalInformationData.birthTown = null;
    this.generalInformationData.birthProvince = null;
  }

  async checkIfEditOrAdd() {
    await this.getDefaultIssuer();
    if (this.generalInformationData && this.generalInformationData.id && this.generalInformationData.id > 0) {
      this.isAdd = false;
      this.initializeForEditGeneralInformation();
      this.newCollegiateNumber = this.generalInformationData.collegiateNumberSuffix && this.generalInformationData.collegiateNumberPrefix ? null : this.generalInformationData.collegiateNumber;
    } else {
      this.isAdd = true;
      this.initializeForAddGeneralInformation();
    }
    this.defaultProvinceSelection();

    if (!this.doctorCorrespondence.id) {
      this.isEdit = false;
      this.initializeForAddDoctorCorrespondence();
      return;
    }
    this.isEdit = true;
    this.searchTown = this.doctorCorrespondence.town ? this.doctorCorrespondence.town.townName : '';
    this.initializeForEditDoctorCorrespondence();    
    this.birthTownRef.nativeElement.click();
  }

  initializeForAddGeneralInformation() {
    this.generalInformationForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      surname1: ['', [Validators.required]],
      surname2: [''],
      birthOfDate: [new Date(), [Validators.required]],
      documentTypeId: [1, [Validators.required]],
      documentTypeValue: ['', [Validators.required]],
      genderId: [null],
      nif: [''],
      nie: [''],
      passport: [''],
      birthProvinceId: [null],
      birthProvinceName: [null],
      birthTownId: [null],
      nationalityByBirthId: [null],
      currentNationalityId: [null],
      doctorRegisteredDate: [new Date(), [Validators.required]],
      mobileNumber: ['', [Validators.pattern('^[0-9]*$')]],
      personalTelephone: ['', [Validators.pattern('^[0-9]*$')]],
      email: ['', [Validators.email]],
      collegeProvinceId: ['', [Validators.required]],
      collegeProvinceName: ['', []],
      ridoUser: [''],
    });
    this.collegeProvinceControl.setValue(null);
    this.selectedProvince = this.selectedProvince;
  }

  initializeForEditGeneralInformation() {
    const date = moment(this.generalInformationData.birthOfDate).format('YYYY-MM-DD');
    this.calculateAge(date, true);

    this.generalInformationForm = this.formBuilder.group({
      name: [this.generalInformationData.name, [Validators.required]],
      surname1: [this.generalInformationData.surname1, [Validators.required]],
      surname2: [this.generalInformationData.surname2],
      birthOfDate: [date, [Validators.required]],
      documentTypeValue: ['', [Validators.required]],
      genderId: [this.generalInformationData.genderId || null],
      documentTypeId: [this.generalInformationData.documentTypeId || 1, [Validators.required]],
      nif: [this.generalInformationData.nif],
      nie: [this.generalInformationData.nie],
      passport: [this.generalInformationData.passport],
      birthProvinceId: this.generalInformationData.birthProvinceId,
      birthProvinceName: this.generalInformationData.birthProvince ? this.generalInformationData.birthProvince.provinceName : '',
      birthTownId: this.generalInformationData.birthTownId,
      nationalityByBirthId: [this.generalInformationData.nationalityByBirthId],
      currentNationalityId: [this.generalInformationData.currentNationalityId],
      collegiateNumber: [this.generalInformationData.collegiateNumber],
      doctorRegisteredDate: [this.generalInformationData.doctorRegisteredDate ? moment(this.generalInformationData.doctorRegisteredDate).format('YYYY-MM-DD') : null, [Validators.required]],
      mobileNumber: [this.generalInformationData.mobileNumber, [Validators.pattern('^[0-9]*$')]],
      personalTelephone: [this.generalInformationData.personalTelephone, [Validators.pattern('^[0-9]*$')]],
      email: [this.generalInformationData.email, [Validators.email]],
      collegeProvinceId: [this.generalInformationData.collegeProvinceId],
      ridoUser: [this.generalInformationData.ridoUser],
    });

    if (this.generalInformationData.documentTypeId != null) {
      if (this.generalInformationData.documentTypeId == DocType.NIF) {
        this.generalInformationForm.get('documentTypeValue').setValue(this.generalInformationData.nif);
      } else if (this.generalInformationData.documentTypeId == DocType.NIE) {
        this.generalInformationForm.get('documentTypeValue').setValue(this.generalInformationData.nie);
      } else if (this.generalInformationData.documentTypeId == DocType.Passport) {
        this.generalInformationForm.get('documentTypeValue').setValue(this.generalInformationData.passport);
      }
      this.generalInformationForm.updateValueAndValidity()
    } else {
      this.generalInformationForm.get('documentTypeValue').setValue(this.generalInformationData.nif)
      this.generalInformationForm.updateValueAndValidity();
    }
    if (this.generalInformationData.collegeProvinceId && this.collegeProvinces.length > 0) {
      const selectedProvince = this.collegeProvinces.find(x => x.id == this.generalInformationData.collegeProvinceId);
      this.collegeProvinceControl.setValue(selectedProvince.provinceName);
      this.selectedProvince = selectedProvince.provinceName;
    } else {
      this.selectedProvince = "";
    }
  }

  initializeForAddDoctorCorrespondence() {
    this.doctorCorrespondenceForm = this.formBuilder.group({
      id: [''],
      mailAttentionId: [0],
      name: [''],
      surname1: [''],
      surname2: [''],
      door: ['', [Validators.required]],
      number: ['', [Validators.required]],
      nameOfVia: ['', [Validators.required]],
      typeOfVia: ['', [Validators.required]],
      postalCode: ['', [Validators.required]],
      townId: [null, [Validators.required]],
      countryName: [''],
      provinceName: ['']
    });
  }

  initializeForEditDoctorCorrespondence() {
    this.doctorCorrespondenceForm = this.formBuilder.group({
      id: [this.doctorCorrespondence.id],
      mailAttentionId: [this.doctorCorrespondence.mailAttentionId || 0],
      name: [this.doctorCorrespondence.name],
      surname1: [this.doctorCorrespondence.surname1],
      surname2: [this.doctorCorrespondence.surname2],
      door: [this.doctorCorrespondence.door, [Validators.required]],
      number: [this.doctorCorrespondence.number, [Validators.required]],
      nameOfVia: [this.doctorCorrespondence.nameOfVia, [Validators.required]],
      typeOfVia: [this.doctorCorrespondence.typeOfVia, [Validators.required]],
      postalCode: [this.doctorCorrespondence.postalCode, [Validators.required]],
      townId: [this.searchTown ? this.searchTown : 0, [Validators.required]],
      countryName: [this.doctorCorrespondence.town ? this.doctorCorrespondence.town.country.countryName : ''],
      provinceName: [this.doctorCorrespondence.town ? this.doctorCorrespondence.town.province.provinceName : '']
    });
  }

  public show() {
    if (localStorage.getItem('locale')) {
      const lang = localStorage.getItem('locale');
      this.generalInformationService.localeId = lang;
    }
    const self = this;
    self.getAuxiliaryValues();

    setTimeout(() => {
      this.submitted = false;
      if (self.generalInformation && self.generalInformation.id) {
        self.generalInformationData = JSON.parse(JSON.stringify(self.generalInformation));
        this.doctorId = self.generalInformationData.id;
        if (self.generalInformationData.imagePathUrl) {
          self.generalInformationData.imagePathUrl = 'data:image/jpg;base64,' + self.generalInformationData.imagePathUrl;
        }
      } else {
        this.generalInformationData = new Doctor();
      }
      if (self.doctorCorrespondenceData && self.doctorCorrespondenceData.id) {
        self.doctorCorrespondence = JSON.parse(JSON.stringify(self.doctorCorrespondenceData));
      } else {
        this.doctorCorrespondence = new DoctorCorrespondence();
      }

      if (this.doctorCorrespondence) {
        this.townID = this.doctorCorrespondence.townId ? this.doctorCorrespondence.townId : null;
        this.provinceId = this.doctorCorrespondence.town ? this.doctorCorrespondence.town.provinceId : null;
        this.countryId = this.doctorCorrespondence.town ? this.doctorCorrespondence.town.countryId : null;
        this.townControl.setValue(this.doctorCorrespondence.town.townName);
      }

      self.isImageChanged = false;
      this.generalInformationForm.reset();
      self.checkIfEditOrAdd();
      if (this.generalInformationData && this.generalInformationData.birthTown) {
        this.birthTownControl.setValue(this.generalInformationData.birthTown.townName);
        this.birthTownRef.nativeElement.click();
      }
      self.child.show();

    }, 500);
  }

  defaultProvinceSelection() {

    const provinceCount = this.collegeProvinces?.length || 0;
    if (provinceCount === 1) {
      this.isProvinceLengthOne = true;
      const { provinceName } = this.collegeProvinces[0];
      this.isProvinceLengthOne = true;
      this.collegeProvinceControl.setValue(provinceName);
      this.selectedProvince = provinceName;
      this.generalInformationForm.controls.collegeProvinceId?.setValue(Number(this.collegeProvinces[0].id));
      this.generalInformationForm.controls.collegeProvinceName?.setValue(this.selectedProvince);
      this.generalInformationForm.updateValueAndValidity();
    } else {
      this.isProvinceLengthOne = false;
    }

  }

  closeModal() {
    this.child.hide();
    this.generalInformationForm.reset();
  }

  handleUpdateItemClick(titleKey: string, messageKey: string, data: any) {
    const nameChanged = this.generalInformationForm.controls.name.dirty;
    const surname1Changed = this.generalInformationForm.controls.surname1.dirty;
    const surname2Changed = this.generalInformationForm.controls.surname2.dirty;
    const documentTypeValueChanged = this.generalInformationForm.controls.documentTypeValue.dirty;

    if ((nameChanged || surname1Changed || surname2Changed || documentTypeValueChanged) && this.generalInformationData.hasDocuments) {
      this.commonUIService.sweetAlert(titleKey, messageKey, null, data).then((response: any) => {
        if (response.action == SweetAlertActions.confirm) this.onSave('clicked');
      })
    }
    else {
      this.onSave('clicked');
    }
  }

  async onSave(data) {
    if (data !== 'clicked') {
      return;
    }
    this.submitted = true;

    if (this.doctorCorrespondenceForm.value.townId == 0) {
      this.doctorCorrespondenceForm.controls.townId.setValue(null);
    }
    if (this.doctorCorrespondenceForm.value.mailAttentionId == 0) {
      this.doctorCorrespondenceForm.controls.mailAttentionId.setValue(null);
    }

    if (!this.commonUIService.validateForm(this.generalInformationForm, this.validationMessages) || !this.commonUIService.validateForm(this.doctorCorrespondenceForm, this.validationMessages)) {
      return;
    } else {
      this.selectedDocument = this.generalInformationForm.get('documentTypeId').value;
      if (this.selectedDocument == DocType.NIF) {
        this.generalInformationData.nif = this.generalInformationForm.get('documentTypeValue').value;
        this.generalInformationForm.get('nif').setValue(this.generalInformationData.nif);
      } else if (this.selectedDocument == DocType.NIE) {
        this.generalInformationData.nie = this.generalInformationForm.get('documentTypeValue').value;
        this.generalInformationForm.get('nie').setValue(this.generalInformationData.nie);
      } else if (this.selectedDocument == DocType.Passport) {
        this.generalInformationData.passport = this.generalInformationForm.get('documentTypeValue').value;
        this.generalInformationForm.get('passport').setValue(this.generalInformationData.passport);
      }
    }

    if (this.generalInformationData) {
      this.generalInformationData.name = this.generalInformationForm.value.name;
      this.generalInformationData.surname1 = this.generalInformationForm.value.surname1;
      this.generalInformationData.surname2 = this.generalInformationForm.value.surname2;
      this.generalInformationData.mobileNumber = this.generalInformationForm.value.mobileNumber;
      this.generalInformationData.personalTelephone = this.generalInformationForm.value.personalTelephone;
      this.generalInformationData.email = this.generalInformationForm.value.email;
      this.generalInformationData.ridoUser = this.generalInformationForm.value.ridoUser;

      this.generalInformationData.genderId = this.generalInformationForm.value.genderId;
      if (this.generalInformationData.gender) this.generalInformationData.gender.id = this.generalInformationForm.value.genderId;

      this.generalInformationData.birthOfDate = changeNgbDateToCustomFormat(this.generalInformationForm.value.birthOfDate).toString();

      this.generalInformationData.birthProvinceId = this.generalInformationForm.value.birthProvinceId;
      if (this.generalInformationData.birthProvince) this.generalInformationData.birthProvince.id = this.generalInformationForm.value.birthProvinceId;

      this.generalInformationData.birthTownId = this.generalInformationForm.value.birthTownId;
      if (this.generalInformationData.birthTown) this.generalInformationData.birthTown.id = this.generalInformationForm.value.birthTownId;

      this.generalInformationData.nationalityByBirthId = this.generalInformationForm.value.nationalityByBirthId;
      if (this.generalInformationData.nationalityByBirth) this.generalInformationData.nationalityByBirth.id = this.generalInformationForm.value.nationalityByBirthId;

      this.generalInformationData.currentNationalityId = this.generalInformationForm.value.currentNationalityId;
      if (this.generalInformationData.currentNationality) this.generalInformationData.currentNationality.id = this.generalInformationForm.value.currentNationalityId;

      this.generalInformationData.collegiateNumber = this.newCollegiateNumber;

      this.generalInformationData.doctorRegisteredDate = (!this.generalInformationForm.value.doctorRegisteredDate) ? null : changeNgbDateToCustomFormat(this.generalInformationForm.value.doctorRegisteredDate);

      this.generalInformationData.country = null
      this.generalInformationData.birthProvince = null
      this.generalInformationData.birthTown = null
      this.generalInformationData.town = null
      this.generalInformationData.currentNationality = null
      this.generalInformationData.gender = null
      this.generalInformationData.nationalityByBirth = null
      this.generalInformationData.province = null
    }


    if (this.generalInformationData && this.generalInformationData.id) {
      if (this.isImageChanged) {
        const imageName = await this.uploadProfileImage();
        this.generalInformationData.imageName = imageName.toString();
      }
      await this.updateDoctorData();
    }else{
      await this.saveDoctorData(this.generalInformationForm.value);
    }
  } 

  private saveCorrespondance(){
    this.doctorCorrespondence = this.doctorCorrespondenceForm.value;
    this.doctorCorrespondence.doctorId = this.doctorId;
    this.doctorCorrespondence.townId = this.townID;
    this.doctorCorrespondence.provinceId = this.provinceId;
    this.doctorCorrespondence.countryId = this.countryId;
    this.doctorCorrespondence.country = null;
    this.doctorCorrespondence.province = null;
    this.doctorCorrespondence.town = null;
    if (this.isEdit) {
      this.updateDoctorCorrespondence(this.doctorCorrespondence);
    }else{
      this.saveDoctorCorrespondence(this.doctorCorrespondence);
    }

    if (this.isAdd) {      
      this.router.navigate(['/doctor/doctor-details/' + this.doctorId]);
    }
  }

  private returnResponse() {
    this.close.emit(this.doctorId);
    this.child.hide();
  }

  saveDoctorCorrespondence(doctorCorrespondence: DoctorCorrespondence) {
    doctorCorrespondence.id = 0;
    this.doctorCorrespondenceService.saveDoctorCorrespondence(doctorCorrespondence).subscribe(
      (_data: any) => {
        this.successToast('doctorCorrespondenceSave');
        this.returnResponse();
      },
      (error) => {
        this.failToast(error._message);
      }
    );
  }

  updateDoctorCorrespondence(doctorCorrespondence: DoctorCorrespondence) {
    this.doctorCorrespondenceService.updateDoctorCorrespondence(doctorCorrespondence.id, doctorCorrespondence).subscribe(
      (_data: any) => {
        this.successToast('doctorCorrespondenceUpdate');
        this.returnResponse();
      },
      (error) => {
        this.failToast(error._message);
      }
    );
  }

  async uploadProfileImage() {
    this.createFileObject();
    return new Promise((resolve, reject) => this.generalInformationService.uploadImage(this.generalInformationData.id.toString(), 'Doctor', 'uploadImage', this.imageFile).subscribe(
      (data: any) => {
        if (data != null && data.hasOwnProperty('body')) {
          this.successToast('successPhotoUploadMessage');
          resolve(data.body.data);
          this.child.hide();
        }
      },
      (error) => {
        this.failToast(error._message);
        reject(false);
      }
    ));
  }

  saveDoctorData(docData: Doctor) {
    this.doctorService.isReload = false;
    docData.birthOfDate = changeNgbDateToCustomFormat(docData.birthOfDate);
    docData.doctorRegisteredDate = changeNgbDateToCustomFormat(docData.doctorRegisteredDate);
    this.generalInformationService.updateHeaderCarousel(true);
    docData.collegiateNumber = this.newCollegiateNumber;
    docData.sendCorrespondenceType = 2;
    this.doctorService.saveDoctorDetails(docData).subscribe(
      async (data: any) => {
        this.successToast('successGeneralMessage');
        this.generalInformationData = data._data;
        this.doctorId = data._data.id;
        this.saveCorrespondance();
        if (this.isImageChanged) {
          const imageName = await this.uploadProfileImage();
          this.generalInformationData.imageName = imageName.toString();
          this.updateDoctorData();
        }
        if (this.doctorService.isCurrentPage) {
          this.doctorService.isReload = true;
        }
      },
      (error) => {
        this.failToast(error._message);
      }
    );
  }

  updateDoctorData() {
    this.generalInformationData.collegiateNumber = this.newCollegiateNumber;
    this.generalInformationData.genderId = this.generalInformationForm.value.genderId;

    this.selectedDocument = this.generalInformationForm.get('documentTypeId').value;
    this.generalInformationData.documentTypeId = this.selectedDocument;
    if (this.selectedDocument == DocType.NIF) {
      this.generalInformationData.nif = this.generalInformationForm.get('documentTypeValue').value;
      this.generalInformationData.nie = "";
      this.generalInformationData.passport = "";
    } else if (this.selectedDocument == DocType.NIE) {
      this.generalInformationData.nie = this.generalInformationForm.get('documentTypeValue').value;
      this.generalInformationData.passport = "";
      this.generalInformationData.nif = "";
    } else if (this.selectedDocument == DocType.Passport) {
      this.generalInformationData.passport = this.generalInformationForm.get('documentTypeValue').value;
      this.generalInformationData.nie = "";
      this.generalInformationData.nif = "";
    }

    this.doctorService.updateDoctorDetails(this.generalInformationData).subscribe(
      (data: any) => {
        this.generalInformationData = null;
        this.successToast('successGeneralUpdateMessage');
        if (data != null)
        this.doctorId = data._data.id;
        this.saveCorrespondance();
        this.generalInformationService.updateHeaderCarousel(true);
      },
      (error) => {
        this.failToast(error._message);
      }
    );
  }

  RegistrationDateKeyUp() {
    const control = this.generalInformationForm.get('doctorRegisteredDate');
    this.commonUIService.validateNgbDate(control as FormControl, true);
  }

  //Birth date auto set format 
  BirthDateKeyUp() {
    const control = this.generalInformationForm.get('birthOfDate');
    this.commonUIService.validateNgbDate(control as FormControl, true);
  }

  changeImage(image) {
    this.isImageChanged = true;
    this.generalInformationData.imagePathUrl = image.base64.toString();
    this.image = image;
  }

  createFileObject() {
    const fileName = new Date().toISOString().replace('.', '').substring(0, 10);
    const imageName = fileName + '.' + this.image.file.type.split('/')[1];
    const imageFile = this.dataURItoBlob(this.image.base64.replace(/^data:image\/(png|jpg);base64,/, ''));
    this.imageFile = new File([imageFile], imageName, { type: this.image.file.type });
  }

  dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    return new Blob([int8Array], { type: 'image/jpeg' });
  }

  isBirthPlaceValueSelected(isValueSelected: any) {
    //value recieved, form group and control name
    this.commonUIService.novasearchDropDownValidator(isValueSelected, this.generalInformationForm, 'birthTownId');
  }

  successToast(messageTranslationKey) {
    this.translationService.get(['success', messageTranslationKey]).subscribe((translations: any) => {
      this.toastService.success(translations[messageTranslationKey], translations.success, {
        timeOut: 5000,
        progressBar: true,
        closeButton: true,
        progressAnimation: 'increasing',
        positionClass: 'toast-bottom-right', // Adjust the position as needed
      });
    });
  }

  failToast(message) {
    this.translationService.get(['errorTitle', message]).subscribe((translations: any) => {
      this.toastService.error(translations[message], translations.success, {
        timeOut: 5000,
        progressBar: true,
        closeButton: true,
        progressAnimation: 'increasing',
        positionClass: 'toast-bottom-right', // Adjust the position as needed
      });
    });
  }

  isTownValueSelected(isValueSelected : any){
    if(isValueSelected=='empty') {
      this.doctorCorrespondenceForm.controls.townId.setValue(null);
      this.doctorCorrespondenceForm.controls.countryName.setValue(null);
      this.doctorCorrespondenceForm.controls.provinceName.setValue(null);
    }
    //value recieved, form group and control name
    this.commonUIService.novasearchDropDownValidator(isValueSelected,  this.doctorCorrespondenceForm, 'townId');
  }

  onClearTowns() {
    this.doctorCorrespondenceForm.controls.townId.setValue(null);
    this.doctorCorrespondenceForm.controls.countryName.setValue(null);
    this.doctorCorrespondenceForm.controls.provinceName.setValue(null);
  }

  onSelectTown(result) {
    if (result) {
      this.searchTown = result.townName;
      if (result.id == 0) {
        this.doctorCorrespondence.town = new Town();
        return;
      }
      this.townID = result.id;
      const town = this.townsList.filter(x => x.id == this.townID)[0];
      this.doctorCorrespondenceForm.controls.countryName.setValue(town.country.countryName);
      this.doctorCorrespondenceForm.controls.provinceName.setValue(town.province.provinceName);
      this.doctorCorrespondenceForm.controls.townId.setValue(this.townID);
      this.countryId = town.countryId;
      this.provinceId = town.provinceId;
    }
  }

  get birthTownId() {
    return this.generalInformationForm.get('birthTownId');
  }

  get name() {
    return this.generalInformationForm.get('name');
  }

  get nif() {
    return this.generalInformationForm.get('nif');
  }

  get nie() {
    return this.generalInformationForm.get('nie');
  }

  get birthOfDate() {
    return this.generalInformationForm.get('birthOfDate');
  }

  get surname1() {
    return this.generalInformationForm.get('surname1');
  }

  get surname2() {
    return this.generalInformationForm.get('surname2');
  }

  get doctorRegisteredDate() {
    return this.generalInformationForm.get('doctorRegisteredDate');
  }

  get documentTypeValue() {
    return this.generalInformationForm.get('documentTypeValue');
  }

  get documentTypeId() {
    return this.generalInformationForm.get('documentTypeId');
  }

  get genderId() {
    return this.generalInformationForm.get('genderId');
  }

  get passport() {
    return this.generalInformationForm.get('passport');
  }

  get birthProvinceId() {
    return this.generalInformationForm.get('birthProvinceId');
  }

  get birthProvinceName() {
    return this.generalInformationForm.get('birthProvinceName');
  }

  get nationalityByBirthId() {
    return this.generalInformationForm.get('nationalityByBirthId');
  }

  get currentNationalityId() {
    return this.generalInformationForm.get('currentNationalityId');
  }

  get collegiateNumber() {
    return this.generalInformationForm.get('collegiateNumber');
  }

  get mobileNumber() {
    return this.generalInformationForm.get('mobileNumber');
  }

  get personalTelephone() {
    return this.generalInformationForm.get('personalTelephone');
  }

  get email() {
    return this.generalInformationForm.get('email');
  }

  get collegeProvinceId() {
    return this.generalInformationForm.get('collegeProvinceId');
  }

  get ridoUser() {
    return this.generalInformationForm.get('ridoUser');
  }



  get number() {
    return this.doctorCorrespondenceForm.get('number');
  }

  get door() {
    return this.doctorCorrespondenceForm.get('door');
  }

  get nameOfVia() {
    return this.doctorCorrespondenceForm.get('nameOfVia');
  }

  get typeOfVia() {
    return this.doctorCorrespondenceForm.get('typeOfVia');
  }

  get postalCode() {
    return this.doctorCorrespondenceForm.get('postalCode');
  }

  get countryName() {
    return this.doctorCorrespondenceForm.get('countryName');
  }

  get provinceName() {
    return this.doctorCorrespondenceForm.get('provinceName');
  }

  get townId() {
    return this.doctorCorrespondenceForm.get('townId');
  }

}
